<template>
    <!--    Grading System-->
    <validation-observer ref="assessmentSettingsForm" v-slot="{ invalid }">
        <lenon-modal :title="'Create Assessment Setting'" :show="assessmentSettingModalOpened"
            extra-classes="grading-system" size="md" :show-overlay="assessmentSettingLoading"
            @onClose="closeAssessmentSettingModal()">
            <error-display :error="error" />
            <b-row>
                <div class="col-12">
                    <lenon-select v-model="assessment.exam_type" name="exam_type" label="Exam Type" :options="examTypes"
                        rules="required" />
                </div>
                <div class="col-12 mt-2" v-if="assessment.exam_type === 'final'">
                    <lenon-multi-select v-model="assessment.final_exams" name="final_exams" label-name="name"
                        value-name="id" label="Affected Final Exams" placeholder="Select Final Exams"
                        :options="finalExams" rules="required" />
                </div>
                <div class="col-12 mt-2" v-if="assessment.exam_type === 'class'">
                    <lenon-multi-select v-model="assessment.class_exams" name="class_exams" label-name="name"
                        value-name="id" label="Select Class Exams" :options="classAssessments" rules="required" />
                </div>
            </b-row>
            <div class="mt-2">
                <strong v-if="assessment.exam_type" class="text-danger">Note: This will update the conducted assessments from {{assessment.exam_type==='final'?'Final Exam':'Class Assessment'}} to {{assessment.exam_type==='final'?'Class Assessment':'Final Exam'}}</strong>
            </div>
            <template slot="modal-actions">
                <b-row class="float-right">
                    <lenon-button variant="flat-danger" icon="XIcon" class="mr-1" label="Cancel"
                        @onClick="closeAssessmentSettingModal()" />
                    <lenon-button label="Update" :disabled="invalid" :loading="assessmentSettingLoading"
                        loading-text="Loading..." @onClick="updateAssessmentSetting()" />
                </b-row>
            </template>
        </lenon-modal>
    </validation-observer>
</template>

<script>
import {
    BRow, BDropdownItem, BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import LenonModal from '@/lenon/components/LenonModal.vue'
import LenonButton from '@/lenon/components/LenonButton.vue'
import showToast from '@/lenon/mixins/showToast'
// eslint-disable-next-line import/extensions
import LenonInput from '@/lenon/components/LenonInput.vue'
import LenonSelect from '@/lenon/components/LenonSelect.vue'
import LenonMultiSelect from '@/lenon/components/LenonMultiSelect.vue'
import {
    CREATE_ASSESSMENT_SETTING,
} from '@/graphql/mutations'
import LenonDropdown from '@/lenon/components/LenonDropdown.vue'
import ErrorDisplay from '@/lenon/components/ErrorDisplay.vue'
export default {
    name: 'AssessmentSettings',
    components: {
        ErrorDisplay,
        LenonDropdown,
        LenonMultiSelect,
        LenonInput,
        LenonButton,
        LenonModal,
        ValidationObserver,
        BRow,
        BDropdownItem,
        BFormCheckbox,
        LenonSelect,
    },
    mixins: [showToast],
    props: {
        modalOpened: { type: Boolean, default: false },
    },
    data() {
        return {
            error: {},
            conductedAssessments: [],
            assessmentSettingModalOpened: false,
            assessmentSettingLoading: false,
            assessment:{
                exam_type: 'class',
                final_exams: [],
                class_exams: []
            }
        }
    },
    computed: {
        finalExams() {
            return this.conductedAssessments.filter(assessment => assessment.is_main_exam)
        },
        classAssessments() {
            return this.conductedAssessments.filter(assessment => !assessment.is_main_exam)
        },
        examTypes() {
            return [
                { label: 'Final Exam', value: 'final' },
                { label: 'Class Assessment', value: 'class' },
            ]
        },
    },
    watch: {
        modalOpened(opened) {
            this.assessmentSettingModalOpened = opened
        },
    },
    methods: {
        getConductedAssessments() {
            this.$http.get('/academics/assessments').then((res) => {
                this.conductedAssessments = res.data
            })
        },
        closeAssessmentSettingModal() {
            this.assessmentSettingModalOpened = false
            this.$emit('modalClosed')
        },
        resetAssessmentSettingForm() {
            this.assessment = {
                exam_type: 'class',
                final_exams: [],
                class_exams: [],
            }
            this.$refs.assessmentSettingsForm.reset()
        },
        updateAssessmentSetting() {
            this.error = {}
            this.assessmentSettingLoading = true
            const ids = this.assessment.exam_type === 'final' ? this.assessment.final_exams.map((ex) => ex.id) : this.assessment.class_exams.map((ex) => ex.id)
            const is_main = this.assessment.exam_type==='final';
            const assessment = {
                assessments: ids,
                is_main_exam: is_main
            }
            this.$http.put('/academics/update-conducted-assessment',assessment).then(res => {
                this.assessmentSettingLoading = false
                this.showSuccess('Updated Successfully')
                this.resetAssessmentSettingForm()
                this.conductedAssessments = this.conductedAssessments.map((ex)=>{
                    if(ids.includes(ex.id)){
                        ex.is_main_exam = is_main;
                    }
                    return ex;
                })
            }).catch(err => {
                this.error = err
                this.showError('Something went wrong, please try again')
            }).finally(() => {
                this.assessmentSettingLoading = false;
            })
        },
    },
    mounted(){
        this.getConductedAssessments()
    }
}
</script>